import { StateUtils } from '@spartacus/core';
import { ReelCutting, ReelCuttingRequest } from '../../../../../core/model';
import { CartEntryReelCuttingActionTypes } from '../actions/cart-entry-reel-cutting.action';
import { CartActions } from '../actions/index';

export const initialState: ReelCutting = undefined;

export function reducer(
  state = initialState,
  action: CartActions.CartEntryReelCuttingActions | StateUtils.LoaderAction
): ReelCutting {
  switch (action.type) {
    case CartEntryReelCuttingActionTypes.AddCartEntryReelCuttingSuccess: {
      const reelCutting: ReelCuttingRequest = action.payload.reelCutting;
      return {
        ...state,
        widths: reelCutting.daughterWidths,
        resultingLength: {
          value: reelCutting.daughterLength,
        },
        remainder: reelCutting.remainder,
      };
    }
    case CartEntryReelCuttingActionTypes.RemoveCartEntryReelCuttingSuccess: {
      return initialState;
    }
  }
  return state;
}
